import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Analytics } from '@vercel/analytics/react';
import MainLayout from './components/layout/MainLayout';
import Home from './pages/Home';
import Compare from './pages/Compare';

const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <MainLayout>
          <Routes>
            <Route path="/" element={<Home />} />
            {/* Add more routes as we create the components */}
            <Route path="/tools" element={<div>Tools Page (Coming Soon)</div>} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/blog" element={<div>Blog Page (Coming Soon)</div>} />
            <Route path="/quiz" element={<div>Quiz Page (Coming Soon)</div>} />
            <Route path="/tool/:id" element={<div>Individual Tool Page (Coming Soon)</div>} />
          </Routes>
        </MainLayout>
        <Analytics />
      </Router>
    </QueryClientProvider>
  );
};

export default App; 